"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Theme = _interopRequireDefault(require("../Theme"));

var _Text = _interopRequireDefault(require("../Text"));

var _Image = _interopRequireDefault(require("../Image"));

var _propTypes = require("prop-types");

var ParentWrapper = _styledComponents.default.div.withConfig({
  displayName: "UserReview__ParentWrapper",
  componentId: "sc-1hi79av-0"
})(["display:flex;flex-direction:column;position:relative;box-sizing:border-box;font-family:'DM Sans';width:", ";border:", ";border-bottom:", ";border-radius:", ";padding:", ";"], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? '320px' : '874px';
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return !isMobile ? '1px solid #d9dbe0' : '';
}, function (_ref3) {
  var isMobile = _ref3.isMobile;
  return isMobile ? '1px solid #d9dbe0' : '';
}, function (_ref4) {
  var isMobile = _ref4.isMobile;
  return !isMobile ? '16px' : '';
}, function (_ref5) {
  var isMobile = _ref5.isMobile;
  return !isMobile ? '32px' : '32px 0';
});

var TopHeader = _styledComponents.default.div.withConfig({
  displayName: "UserReview__TopHeader",
  componentId: "sc-1hi79av-1"
})(["display:flex;justify-content:space-between;width:100%;"]);

var Logo = _styledComponents.default.div.withConfig({
  displayName: "UserReview__Logo",
  componentId: "sc-1hi79av-2"
})(["max-width:100px;"]);

var RatingArea = _styledComponents.default.div.withConfig({
  displayName: "UserReview__RatingArea",
  componentId: "sc-1hi79av-3"
})(["display:flex;flex-direction:row;align-items:center;height:39px;"]);

var UserRating = _styledComponents.default.div.withConfig({
  displayName: "UserReview__UserRating",
  componentId: "sc-1hi79av-4"
})(["display:flex;flex-direction:row;justify-content:center;align-items:center;padding:4px 10px;width:36px;height:32px;color:#ffffff;font-weight:500;font-size:14px;line-height:150%;box-sizing:border-box;margin-right:12px;background:", ";border-radius:12px 12px 0px 12px;"], function (_ref6) {
  var move = _ref6.move;
  return move ? '#023C40' : '#4B4FA6';
});

var UserRaitingTextArea = _styledComponents.default.div.withConfig({
  displayName: "UserReview__UserRaitingTextArea",
  componentId: "sc-1hi79av-5"
})(["display:flex;flex-direction:column;justify-content:space-around;height:39px;"]);

var UserReviewTitel = _styledComponents.default.div.withConfig({
  displayName: "UserReview__UserReviewTitel",
  componentId: "sc-1hi79av-6"
})(["height:18px;font-weight:500;font-size:12px;line-height:150%;color:", ";", ";"], function (_ref7) {
  var move = _ref7.move;
  return move ? '#023C40' : '#4b4fa6';
}, function (_ref8) {
  var isMobile = _ref8.isMobile;
  return isMobile && "width: 117px;\n    overflow: hidden;\n    white-space: nowrap;\n    text-overflow: ellipsis;";
});

var ReviewBody = _styledComponents.default.div.withConfig({
  displayName: "UserReview__ReviewBody",
  componentId: "sc-1hi79av-7"
})(["display:flex;flex-direction:column;margin-top:12px;"]);

var HorizontalBar = _styledComponents.default.div.withConfig({
  displayName: "UserReview__HorizontalBar",
  componentId: "sc-1hi79av-8"
})(["border-bottom:1px solid lightgrey;margin:12px 0;"]);

var UserReview = function UserReview(_ref9) {
  var source = _ref9.source,
      tripReason = _ref9.trip_reason,
      dateSubmitted = _ref9.date_submitted,
      rating = _ref9.rating,
      reviewerName = _ref9.reviewer_name,
      text = _ref9.text,
      ratingLabel = _ref9.rating_label,
      isMobile = _ref9.isMobile,
      title = _ref9.title,
      theme = _ref9.theme,
      move = _ref9.move;
  var url = "https://storage.googleapis.com/static.airasia.com/design/logos/".concat(source, ".png");
  return /*#__PURE__*/_react.default.createElement(_Theme.default, {
    theme: theme
  }, /*#__PURE__*/_react.default.createElement(ParentWrapper, {
    isMobile: isMobile
  }, /*#__PURE__*/_react.default.createElement(TopHeader, null, /*#__PURE__*/_react.default.createElement(RatingArea, null, /*#__PURE__*/_react.default.createElement(UserRating, {
    theme: theme,
    move: move
  }, rating), /*#__PURE__*/_react.default.createElement(UserRaitingTextArea, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    Theme: theme,
    color: "neutral",
    type: "textSmall",
    bold: true,
    customProperties: {
      fontWeight: 500,
      lineHeight: '150%'
    }
  }, ratingLabel), tripReason && /*#__PURE__*/_react.default.createElement(UserReviewTitel, {
    isMobile: isMobile,
    move: move
  }, ' ', tripReason, ' '))), /*#__PURE__*/_react.default.createElement(Logo, null, /*#__PURE__*/_react.default.createElement(_Image.default, {
    src: url,
    height: "20px",
    radius: "2px"
  }))), /*#__PURE__*/_react.default.createElement(ReviewBody, null, /*#__PURE__*/_react.default.createElement(_Text.default, {
    Theme: theme,
    marginBottom: "micro",
    color: "neutral",
    type: "textSmall",
    bold: true,
    customProperties: {
      fontWeight: 500,
      lineHeight: '150%'
    }
  }, title), /*#__PURE__*/_react.default.createElement(_Text.default, {
    Theme: theme,
    color: "greyDark",
    type: "textSmall",
    bold: true,
    customProperties: {
      fontWeight: 400,
      lineHeight: '150%'
    }
  }, text), /*#__PURE__*/_react.default.createElement(HorizontalBar, null), /*#__PURE__*/_react.default.createElement(_Text.default, {
    Theme: theme,
    color: "greyDark",
    type: "small",
    bold: true,
    customProperties: {
      fontWeight: 400,
      lineHeight: '150%'
    }
  }, "".concat(reviewerName, ", ").concat(dateSubmitted)))));
};

UserReview.propTypes = {
  source: _propTypes.string,
  trip_reason: _propTypes.string,
  date_submitted: _propTypes.string,
  rating: _propTypes.string,
  reviewer_name: _propTypes.string,
  text: _propTypes.string,
  rating_label: _propTypes.string,
  isMobile: _propTypes.bool,
  title: _propTypes.string,
  theme: _propTypes.string,
  move: _propTypes.bool
};
UserReview.defaultProps = {
  source: '',
  trip_reason: '',
  date_submitted: '',
  rating: '',
  reviewer_name: '',
  text: '',
  rating_label: '',
  isMobile: false,
  title: '',
  theme: 'AIRASIA_CLASSIC',
  move: false
};
var _default = UserReview;
exports.default = _default;